import React from 'react';

const QuestionMarkInCircle = ({
  width = '12',
  height = '12',
  className = '',
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      role="img"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M3.40625 12.5938C2.83125 12.0188 3.2125 10.8125 2.91875 10.1062C2.625 9.4 1.5 8.78125 1.5 8C1.5 7.21875 2.6125 6.625 2.91875 5.89375C3.225 5.1625 2.83125 3.98125 3.40625 3.40625C3.98125 2.83125 5.1875 3.2125 5.89375 2.91875C6.6 2.625 7.21875 1.5 8 1.5C8.78125 1.5 9.375 2.6125 10.1062 2.91875C10.8375 3.225 12.0188 2.83125 12.5938 3.40625C13.1687 3.98125 12.7875 5.1875 13.0813 5.89375C13.375 6.6 14.5 7.21875 14.5 8C14.5 8.78125 13.3875 9.375 13.0813 10.1062C12.775 10.8375 13.1687 12.0188 12.5938 12.5938C12.0188 13.1687 10.8125 12.7875 10.1062 13.0813C9.4 13.375 8.78125 14.5 8 14.5C7.21875 14.5 6.625 13.3875 5.89375 13.0813C5.1625 12.775 3.98125 13.1687 3.40625 12.5938Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 10.8358 8.41421 10.5 8 10.5C7.58579 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 7.58579 12 8 12Z"
        fill="#666666"
      />
      <path
        d="M8 9V8.5C8.34612 8.5 8.68446 8.39736 8.97225 8.20507C9.26003 8.01278 9.48434 7.73947 9.61679 7.4197C9.74924 7.09993 9.7839 6.74806 9.71637 6.40859C9.64885 6.06913 9.48218 5.75731 9.23744 5.51256C8.9927 5.26782 8.68087 5.10115 8.34141 5.03363C8.00194 4.9661 7.65007 5.00076 7.3303 5.13321C7.01053 5.26566 6.73722 5.48997 6.54493 5.77775C6.35264 6.06554 6.25 6.40388 6.25 6.75"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default QuestionMarkInCircle;
